<!-- app页面——知识 -->
<template>
  <div class="knowledgeH5">
    <van-image width="100vw" height="25vh" fit="cover" :src="titleTip" />
    <!-- 功能模块 -->
    <div class="modules">
      <div v-for="(item, index) in authDocList" :key="index" class="moduleItem" @click="toPath(item)">
        <van-image class="leftIcon" fit="contain" :src="getIcon(item)" />
        <span>{{ item.name }}</span>
        <van-icon name="arrow" class="rightIcon" />
      </div>
      <div v-if="!authDocList.length" class="empty">暂无权限</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getMenuList } from "@/CommonDP/utils/tree";

export default {
  components: {},
  data() {
    return {
      titleTip: require("./assets/knowledgeH5.png"), // 图标
      personDoc: require("./assets/personDoc.png"),
      enterpriseDoc: require("./assets/enterpriseDoc.png"),
      deptDoc: require("./assets/deptDoc.png")
    };
  },
  computed: {
    ...mapState({
      authRoutes: (state) => state.router.authRoutes // 当前用户权限
    }),
    // 用户有权限的文档目录
    authDocList() {
      const doc = this.authRoutes.find(({ permissionKey }) => permissionKey === "doc");
      const docList = doc ? this.menuList([doc]) : []; // 知识菜单列表
      return docList;
    }
  },
  // created () {
  //   this.$store.dispatch("GetModuleList");
  // },
  methods: {
    // 对象转菜单列表
    menuList(array) {
      const list = getMenuList(array) || [];
      if (list.length > 0) {
        if (list[0].sub && list[0].sub.length > 0) {
          list[0].sub = list[0].sub.filter(({ resourceType }) => resourceType === 0);
          return list[0].sub;
        }
      }
      return [];
    },

    // 模块图标
    getIcon(item) {
      const { path } = item || {};
      let icon = "";
      switch (path) {
        case "/persondoc":
          icon = this.personDoc;
          break;
        case "/enterprisedoc":
          icon = this.enterpriseDoc;
          break;
        case "/enterpriseDeptDoc":
          icon = this.deptDoc;
          break;
      }
      return icon;
    },
    // 跳转路径
    toPath(item) {
      const { path } = item || {};
      switch (path) {
        case "/persondoc":
          this.$router.push("/personDocH5");
          break;
        case "/enterprisedoc":
          this.$router.push("/enterpriseDocH5");
          break;
        case "/enterpriseDeptDoc":
          this.$router.push("/deptDocH5");
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.knowledgeH5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f6fa;

  .modules {
    width: 100%;
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .empty {
      width: 100%;
      height: calc(100% - 66px);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--info-color)9;
      font-size: 16px;
    }
  }
}

.moduleItem {
  width: 92vw;
  height: 68px;
  padding: 0 5px;
  margin: 5px 0;
  background: #ffffff;
  box-shadow: 0px 0px 15px 0px #3873fe0f;
  border-radius: 5px;
  display: flex;
  align-items: center;

  .leftIcon {
    width: 30px;
    height: 30px;
    margin: 6px;
  }

  span {
    font-size: 16px;
    font-weight: 400;
    color: var(--key-color);
  }

  .rightIcon {
    font-size: 14px;
    color: #6f6f6f;
    margin-left: auto;
    margin-right: 10px;
  }
}
</style>
